import styled from "styled-components"
import image from "../../../../../images/poll-empty.png"

const ICON_SIZE = 120

const PollIcon = styled.img.attrs({
  alt: "poll",
  width: `${ICON_SIZE}px`,
  height: `${ICON_SIZE}px`,
  src: image
})`
  margin-bottom: 30px;
`
export default PollIcon
